import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page3Pc from './Page3Pc'
import Page3Mobile from './Page3Mobile'
import { useEffect, useState } from 'react'
import { fetchGoods } from '../../api/x_goods'
import { useParams } from 'react-router-dom'

function Page3() {
  const [goods, setGoods] = useState([])
  let { id } = useParams()

  useEffect(() => {
    async function fetchGoodsData() {
      const response = await fetchGoods({ useYn: 'Y', id })
      const data = response.data.data
      setGoods(data)
    }
    fetchGoodsData()
  }, [])
  return (
    <>
      <Pc>
        <Page3Pc goods={goods} gsId={id} />
      </Pc>
      <Mobile>{goods && <Page3Mobile goods={goods} gsId={id} />}</Mobile>
    </>
  )
}

export default Page3
